<div class="certification-container">
    <div class="container">
        <div class="certification-content">
            <div class="text-section">
                <h2>Industry Recognized Certifications</h2>
                <p>
                    Get certified with a course completion certificate that validates your expertise and is recognized
                    by
                    top industry professionals.
                </p>
                <ul class="features">
                    <li>
                        <i class="fa-regular fa-circle-check"></i>
                        <div>
                            <strong>Gain Credibility</strong>
                            <p>Validate your skills with our industry-recognized certification.</p>
                        </div>
                    </li>
                    <li>
                        <i class="fa-regular fa-circle-check"></i>
                        <div>
                            <strong>Enhance Your Profile</strong>
                            <p>Boost your career prospects with a certificate that stands out.</p>
                        </div>
                    </li>
                    <li>
                        <i class="fa-regular fa-circle-check"></i>
                        <div>
                            <strong>Showcase Your Expertise</strong>
                            <p>Share your achievement on LinkedIn and job portals.</p>
                        </div>
                    </li>
                </ul>
            </div>


            <div class="certificate-image">
                <img src="{{certificateImage}}" alt="Certificate" />
            </div>
        </div>
    </div>

</div>


<div class="container features-of-joining-certification-program">
    <h2>Why Earn an AlgoTutor Certificate?</h2>
    <div class="certification-cards">
        <div class="card" *ngFor="let card of cards">
            <img [src]="'assets/' + card.icon" [alt]="card.title" />
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
        </div>
    </div>

</div>



<div class="certification-container">
    <div class="cta-section container">
        <h3>Ready to Get Certified?</h3>
        <a href="{{link}}" target="_blank">
            <button class="enroll-btn">Register Now</button>
        </a>

    </div>
</div>